import { makeAutoObservable } from "mobx"

export default class CampaignScenariosProjectAsset {
  constructor(campaignScenariosProjectAsset = {}) {
    this.id = campaignScenariosProjectAsset.id
    this.project_asset_id = campaignScenariosProjectAsset.project_asset_id
    this.campaign_scenario_id = campaignScenariosProjectAsset.campaign_scenario_id
    this.start_date = campaignScenariosProjectAsset.start_date
    this.end_date = campaignScenariosProjectAsset.end_date
    this.name = campaignScenariosProjectAsset.name
    this.theme_color = campaignScenariosProjectAsset.theme_color
    this.notes = campaignScenariosProjectAsset.notes ?? ''

    makeAutoObservable(this)
  }
}